import { module } from 'modujs';
import { gsap } from 'gsap';
import { lerp } from '../utils/maths';

// data-module-timeline="background"
// data-timeline-from='{"backgroundColor":"white"}'
// data-timeline-to='{"backgroundColor":"black"}'
// 
// CONDITION
// You can set a condition with this.condition, and set data-timeline-condition
// if condition is true, 
// - You can add data-timeline-from-condition, and data-timeline-to-condition
// - Or disabled the timeline  with data-timeline-condition-disabled

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.condition = window.innerWidth < window.innerHeight;
        
        this.hasCondition = typeof this.getData('condition') == 'string';
        this.disabledIfCondition = typeof this.getData('condition-disabled') == 'string';        
        
        if(this.hasCondition) {
            this.bindResize = this.resize.bind(this);
            window.addEventListener('resize', this.bindResize);    
        }

        this.createTimeline();

        this.progressValue = 0;
    }

    createTimeline() {
        this.from = JSON.parse(this.getData('from'));
        this.to = JSON.parse(this.getData('to'));

        if(this.hasCondition && this.condition) {
            this.from = JSON.parse(this.getData('from-condition'));
            this.to = JSON.parse(this.getData('to-condition'));
        }

        this.tl = new gsap.timeline();
        this.tl.pause();
        this.tl.fromTo(this.el,{
            ...this.from
        }, {
            ...this.to,
            ease: 'none',
            force3D: true,
            duration: 1
        });
    }

    trigger(e) {
        if(window.isMobile) {
            if(e.mode == 'enter') {
                this.update();
            } else {
                cancelAnimationFrame(this.raf);
            }
        }
    }
    
    progress({progress, isReversed}) {
        let relativeProgress = progress;
        if(isReversed) relativeProgress = 1-progress;

        this.progressValue = relativeProgress;
        // if(window.isMobile) {
        //     this.progressAim = relativeProgress;
        // } else {
            if(this.tl != undefined) {
                this.tl.progress(this.progressValue);
            }
        // }
        
        
    }

    update() {
        
        this.raf = window.requestAnimationFrame(() => this.update());
        this.progressValue = lerp(this.progressValue, this.progressAim, 0.3);

        this.tl.progress(this.progressValue);

    }

    resize() {
        let oldCondition = this.condition;

        this.condition = window.innerWidth < window.innerHeight;

        if(oldCondition != this.condition) {
            if(this.disabledIfCondition && this.condition) {
                this.tl = undefined;
            }
            if(!this.condition || (!this.disabledIfCondition && this.condition)) {
                this.tl = undefined;
                this.createTimeline();
            }
        }
    }

    destroy() {
        window.removeEventListener('resize', this.bindResize);
        cancelAnimationFrame(this.raf);

    }
}
